module.exports = __webpack_public_path__ + "img/connect-icon.52d87a19.svg";